<div *ngIf="layout.isWeb$ | async" class="header">
    <div class="header-root">
        <div class="header-container container-fluid-header">
            <div class="cpsLogoDiv">
                <span class="cpsLogoText">
                    <img src="assets/images/CPhAHubLogo.svg">
                </span>
            </div>

            <div class="right-menu">
                <button class="goToCpsButton" *ngIf="showHeaderButtons" (click)="goToCps()">
                    {{ 'Home.gotocps' | translate }}
                </button>

                <span class="logoutText" *ngIf="showHeaderButtons" (click)="logout()">{{ 'Home.logout' | translate }}</span>
                <span class="divider">|</span>

                <div class="langChangeText" (click)="changeLang()">
                  <span>{{ languageChangeText }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="layout.isTablet$ | async" class="header">
    <div class="header-root">
        <div class="header-container container-fluid-header">
            <div class="cpsLogoDiv">
                <span class="cpsLogoText">
                    <img src="assets/images/CPhAHubLogo.svg">
                </span>
            </div>

            <div class="right-menu">
                <button class="goToCpsButton" *ngIf="showHeaderButtons" (click)="goToCps()">
                    {{ 'Home.gotocps' | translate }}
                </button>
                <div *ngIf="!showHeaderButtons" class="langChangeText" (click)="changeLang()">
                    <span>{{ languageChangeText }}</span>
                </div>
                <div *ngIf="showHeaderButtons" class="utilNav-menu" (mouseleave)="onUtilNavMouseLeave()">
                    <ul class="nav nav-pills">
                        <li class="utilNav-menuItem" ngbDropdown (mouseenter)="hoverOnUser()" (mouseleave)="leaveUserDropdown()" #userDropdown="ngbDropdown">
                            <ng-container>
                                <a ngbDropdownToggle tabindex="0" (focus)="userDropdown.open()" (click)="userDropdown.open()" class="userdropdown-toggle">
                                    <img src="assets/images/ellipsis.png">
                                </a>
                                <ul class="utilNav-menuList" ngbDropdownMenu (mouseleave)="leaveUserDropdown()">
                                    <li ngbDropdownItem (click)="logout()">
                                        <span class="header-menu-item" *ngIf="showHeaderButtons" >{{ 'Home.logout' | translate }}</span>
                                    </li>
                                    <li ngbDropdownItem (click)="changeLang()">
                                        <span class="header-menu-item" >{{ languageChangeText }}</span>
                                    </li>
                                </ul>
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="layout.isHandset$ | async" class="header">
    <div class="header-root">
        <div class="header-container container-fluid-header">
            <div class="cpsLogoDiv">
                <span class="cpsLogoText">
                    <img src="assets/images/CPhAHubLogo.svg">
                </span>
            </div>

            <div class="right-menu">
                <button class="goToCpsButton" *ngIf="showHeaderButtons" (click)="goToCps()">
                    {{ 'Home.gotocps' | translate }}
                </button>
                <div *ngIf="!showHeaderButtons" class="langChangeText" (click)="changeLang()">
                    <span>{{ languageChangeText }}</span>
                </div>
                <div *ngIf="showHeaderButtons" class="utilNav-menu" (mouseleave)="onUtilNavMouseLeave()">
                    <ul class="nav nav-pills">
                        <li class="utilNav-menuItem" ngbDropdown (mouseenter)="hoverOnUser()" (mouseleave)="leaveUserDropdown()">
                            <ng-container>
                                <a ngbDropdownToggle tabindex="0" (focus)="userDropdown.open()" (click)="userDropdown.open()" class="userdropdown-toggle">
                                    <img src="assets/images/ellipsis.png">
                                </a>
                                <ul class="utilNav-menuList" ngbDropdownMenu (mouseleave)="leaveUserDropdown()">
                                    <li ngbDropdownItem (click)="logout()">
                                        <span class="header-menu-item" *ngIf="showHeaderButtons" >{{ 'Home.logout' | translate }}</span>
                                    </li>
                                    <li ngbDropdownItem (click)="changeLang()">
                                        <span class="header-menu-item" >{{ languageChangeText }}</span>
                                    </li>
                                </ul>
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
